import { render, staticRenderFns } from "./NewEducationField.vue?vue&type=template&id=07b7eee0&scoped=true"
import script from "./NewEducationField.vue?vue&type=script&lang=js"
export * from "./NewEducationField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07b7eee0",
  null
  
)

export default component.exports